import { authFetch } from "~/services/fetch";
import { IWarehouse } from "../interface";

interface getWarehouseByIdProps { 
  readonly warehouseByUser?: boolean
}

export async function getAllWarehouses({ warehouseByUser = false }: getWarehouseByIdProps): Promise<readonly IWarehouse[]> {
  const url = warehouseByUser ? '/warehouse/all-for-logged-user' : '/warehouse'
  try {
    const { data } = await authFetch({
      url: url,
      method: 'GET',
    });
    return data;
  } catch (error) {
    throw error;
  }
}
